export default __webpack_public_path__ + "static/media/Logo.aad363da.png";